import React from 'react';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';

const Fade = ({
  in: inProp,
  children,
  duration,
  timeout,
  animationFrom
}) => {
  const transitionStyles = () => ({
    entering: { opacity: 0, [animationFrom]: '-50px', },
    entered: { opacity: 1, [animationFrom]: '0', },
  });
  const defaultStyle = () => ({
    transition: `all ${duration}ms ease-in-out`,
    opacity: 0,
    [animationFrom]: '-50px',
    position: 'relative',
  });
  return (
    <Transition
      in={inProp}
      timeout={timeout}>
      {state => (
        <div style={{
          ...defaultStyle(),
          ...transitionStyles()[state],
        }}
        >
          { children }
        </div>
      )}
    </Transition>
  );
};

Fade.defaultProps = {
  timeout: 300,
  duration: 300,
};

Fade.propTypes = {
  in: PropTypes.any,
  timeout: PropTypes.number,
  duration: PropTypes.number,
  children: PropTypes.any,
  animationFrom: PropTypes.string
};

export default Fade;
